import { createApiErrorFromResponse, readApiErrorContext } from "@airange/shared/api";

export const CENTER_OPENAPI_ORIGIN_OPTIONS = { mode: "origin" } as const;

export function parseCenterJson<T>(response: Response): Promise<T> {
  if (response.status === 204) {
    return Promise.reject(
      createApiErrorFromResponse(response, {
        code: "admin.access.api_empty_response",
        message: "Admin center API endpoint returned 204 No Content where JSON was required.",
      }),
    );
  }
  return response.text().then((text) => {
    if (!text) {
      throw createApiErrorFromResponse(response, {
        code: "admin.access.api_empty_response",
        message: "Admin center API endpoint returned an empty JSON response.",
      });
    }
    return JSON.parse(text) as T;
  });
}
